export default class Answer {
    constructor(id, text) {
        this.id = id.toString();
        this.text = text;
    }

    getText() {
        return this.text;
    }

    getId() {
        return this.id;
    }
}

Answer.prototype.toString = function() {
    return this.text;
}